import type { IBraintree, IPayPal } from '@/types/PaymentGatewayTypes.ts'
import axios from 'axios'
import { ApiPost } from '@/api/Common.ts'
import type { AxiosError } from 'axios'
import { trackAddPaymentInfo } from '@/analytics/index'
import { HidePayPalButtonPlaceholder } from '@/services/AoeHelpers.ts'
declare const braintree: IBraintree
declare const paypal: IPayPal

class AoeBraintreePaypalVault {
  clientToken = ''
  container = ''
  nonce = ''
  paypalScriptUrl = ''
  braintreeScriptUrl = ''
  createPaymentUrl = ''
  cartCurrency = 'EUR'
  cartFunnelType: 'individual' | 'party' | 'recruitment' = 'individual'
  sourceValues = {
    systemKeyword: '',
    aOECartIdToken: '',
  }
  paymentValues = {
    paymentAmount: '',
  }
  Initialize() {
    console.log('Braintree Paypal Vault', 'Initialize')
    axios.get(this.paypalScriptUrl).then(() => {
      console.log('Braintree Paypal Vault', 'paypalScriptUrl done')
      axios.get(this.braintreeScriptUrl).then(() => {
        console.log('Braintree Paypal Vault', 'braintreeScriptUrl done')
        this.InitializeDocumentReady()
      })
    })
  }
  InitializeDocumentReady() {
    console.log('Braintree Paypal Vault', 'InitializeDocumentReady')

    // Create a client.
    braintree.client.create(
      {
        authorization: this.clientToken,
      },
      (clientErr: object, clientInstance: object) => {
        console.log('braintree.client.create')
        // Stop if there was a problem creating the client.
        // This could happen if there is a network error or if the authorization
        // is invalid.
        if (clientErr) {
          console.error(clientErr)
          return
        }

        // Create a PayPal Checkout component.
        braintree.paypalCheckout.create(
          {
            client: clientInstance,
          },
          (paypalCheckoutErr, paypalCheckoutInstance) => {
            console.log('braintree.paypalCheckout.create')
            // If an error occurred, log it
            if (paypalCheckoutErr) {
              console.error(paypalCheckoutErr)
              return
            }

            paypalCheckoutInstance.loadPayPalSDK(
              {
                vault: true,
              },
              () => {
                console.log('paypalCheckoutInstance.loadPayPalSDK')
                paypal
                  .Buttons({
                    fundingSource: paypal.FUNDING.PAYPAL,

                    createBillingAgreement: () => {
                      return paypalCheckoutInstance.createPayment({
                        flow: 'vault',
                      })
                    },

                    onApprove: (data: object) => {
                      console.log('onApprove')
                      return paypalCheckoutInstance.tokenizePayment(
                        data,
                        (err, payload) => {
                          // If an error occurred, log it
                          if (err) {
                            console.error(err)
                            return
                          }

                          // Save the payment details
                          this.CreatePayment(payload)
                        },
                      )
                    },

                    onCancel: () => {
                      console.log('onCancel')
                    },

                    onError: (err: object) => {
                      console.error(err)
                    },
                  })
                  .render('#braintreepaypalbutton')
                  .then(() => {
                    HidePayPalButtonPlaceholder()
                  })
              },
            )
          },
        )
      },
    )
  }
  CreatePayment(payload: object) {
    console.debug('SavePayment', payload)
    const jsonDataToSave = {
      systemKeyword: this.sourceValues.systemKeyword,
      aOECartIdToken: this.sourceValues.aOECartIdToken,
      BraintreePayPalTokenizeResponse: {
        ...payload,
        clientToken: this.clientToken,
        flow: 'vault',
      },
      charge: Number(this.paymentValues.paymentAmount),
    }
    if (this.createPaymentUrl && this.createPaymentUrl.length > 0) {
      ApiPost(this.createPaymentUrl, jsonDataToSave)
        .then((result: object) => {
          console.log('Processing complete', result)
          trackAddPaymentInfo(
            'paypal',
            Number(this.paymentValues.paymentAmount) || 0,
            this.cartCurrency || 'EUR',
            this.cartFunnelType || 'individual'
          )
          const successMessage = {
            messageType: 'aoepaymentcreated',
            messageData: result,
          }
          window.postMessage(successMessage)
        })
        .catch((errorResult: object) => {
          console.log('Processing error', errorResult)
          const axiosError = errorResult as AxiosError
          let messageData = null
          if (axiosError) {
            messageData = axiosError.response?.data
          }
          const errorMessage = {
            messageType: 'aoepaymentcreationerror',
            messageData: messageData,
          }
          window.postMessage(errorMessage)
        })
    } else {
      console.error('createPaymentUrl is empty')
    }
  }
}

export const aoeBraintreePaypalVault = new AoeBraintreePaypalVault()
